import React from 'react'
import Useletter from '../Useletter'
import Foter from '../Foter'

function Delivery() {
  return (
    <div>
              <div className="contact" style={{textAlign:"left",marginLeft:"20px", fontFamily:"Alata,sans serif",color:"#303030",fontSize:"16px"}}><label htmlFor=""><strong>DELIVERY TIME</strong></label></div>
<div className="point">
    <ul style={{  listStylePosition: "inside",textAlign:"left", fontFamily:"Alata,sans serif",fontSize:"14px"}}>
        <li style={{ marginBottom: "10px" }}>The estimated average Delivery time (after the order is dispatched) across <strong>Pakistan</strong>&nbsp;is 2 to 4 working days for the major cities. For remote areas delivery can take <br /><span style={{textAlign:"left",marginLeft:"23px"}}> longer.</span></li>
   <li style={{ marginBottom: "10px" }}>You are requested to be available on the provided contact number so our team can reach you.</li>
   <li style={{ marginBottom: "10px" }}>Timely delivery is subjected to availability of the articles and order confirmation.
   </li>   
   <li style={{ marginBottom: "10px" }}>During sale period, both order processing and delivery may take longer than usual.</li>   
   </ul>
</div>
 <p style={{textAlign:"left", fontFamily:"Alata,sans serif",fontSize:"14px",}}><strong>Note:</strong>
 To avoid unsafe delivery, we strongly suggest getting your orders delivered to your own address. J. will not be liable for any loss or damage to the order in the case of delivery at the self-pickup point, such as any courier office.
 </p>
 <div className="contact" style={{textAlign:"left",marginLeft:"20px", fontFamily:"Alata,sans serif",color:"#303030",fontSize:"16px",marginBottom: "10px"}}><label htmlFor=""><strong>INTERNATIONAL DELIVERY</strong></label></div>
<ul style={{  listStylePosition: "inside",textAlign:"left", fontFamily:"Alata,sans serif",fontSize:"14px",}}>
<li style={{ marginBottom: "10px" }}>The estimated dispatch time for International order is 5 to 7 working after the order has been confirmed.</li>
<li style={{ marginBottom: "10px" }}>The delivery time may vary depending on the destination.</li>
<li style={{ marginBottom: "10px" }}>J. will not be responsible for any refund if the consignee requests for order cancelation once the order "is in process".</li>
<li style={{ marginBottom: "10px" }}>Customers will be liable to bear the shipment and custom charges if they refuse or receive the delivery.
</li>
<li style={{ marginBottom: "10px" }}>During Sale events, average delivery time can exceed than normal
</li>
</ul>
<div className="contact" style={{textAlign:"left",marginLeft:"20px", fontFamily:"Alata,sans serif",color:"#303030",fontSize:"16px",marginBottom: "10px"}}><label htmlFor=""><strong>CANCELLATION POLICY</strong></label></div>
<ul style={{  listStylePosition: "inside",textAlign:"left", fontFamily:"Alata,sans serif",fontSize:"14px",}}>

<li style={{ marginBottom: "10px" }}>To cancel a prepaid order, please reach out to us within 6 hours of placing your order. Upon cancellation, refund will be made via store credit/credit voucher.</li>
<li style={{ marginBottom: "10px" }}>Once the Order is “in process”, it can no longer be canceled or refunded.
</li>
</ul>
<div className="contact" style={{textAlign:"left",marginLeft:"20px", fontFamily:"Alata,sans serif",color:"#303030",fontSize:"16px",marginBottom: "10px"}}><label htmlFor=""><strong>PAYMENT THROUGH CARD</strong></label></div>
<ul style={{  listStylePosition: "inside",textAlign:"left", fontFamily:"Alata,sans serif",fontSize:"14px",}}>

<li style={{ marginBottom: "10px" }}>We aim to provide a safe and secure shopping experience. However, In some instances, we might need some form of payment verification or source to process the order, which will be requested from the consignee through call or email as per the bank's instructions to avoid any fraudulent or suspicious transactions. <a href="/payment"> ( For Further Instruction Please Click )</a>
</li>
<li style={{ marginBottom: "10px" }}>J. reserves the right to cancel orders if the payment is declined by your authorized payment institution.

</li>
</ul>


<div className="contact" style={{textAlign:"left",marginLeft:"20px", fontFamily:"Alata,sans serif",color:"#303030",fontSize:"16px",marginBottom: "10px"}}><label htmlFor=""><strong>DELIVERY CHARGES</strong></label></div>
<ul style={{  listStylePosition: "inside",textAlign:"left", fontFamily:"Alata,sans serif",fontSize:"14px",}}>

<li style={{ marginBottom: "10px" }}>Shipping charges of Flat Rs.149 will be charged on all orders delivered within Pakistan.</li>
<li style={{ marginBottom: "10px" }}>Charges for all  <strong>International delivery</strong> vary from country to country depending upon city, state, country, and locality. To calculate shipment charges you can select any product and checkout with your delivery address to calculate the estimated delivery charges (doesn’t include any taxes & duties).</li>
<li style={{ marginBottom: "10px" }}><strong>Charges for all International delivery vary from country to country depending upon city, state, country, and locality. To calculate shipment charges you can select any product and checkout with your delivery address to calculate the estimated delivery charges (doesn’t include any taxes & duties).
</strong></li>
</ul>


<div className="contact" style={{textAlign:"left",marginLeft:"20px", fontFamily:"Alata,sans serif",color:"#303030",fontSize:"16px",marginBottom: "10px"}}><label htmlFor=""><strong>TRACK YOUR ORDER</strong></label></div>
<ul style={{  listStylePosition: "inside",textAlign:"left", fontFamily:"Alata,sans serif",fontSize:"14px",}}>

<li style={{ marginBottom: "10px" }}>Once your order is dispatched you will receive an email/SMS with your tracking number.</li>
<li style={{ marginBottom: "10px" }}>You can track your order on the respective courier website mentioned in your email.
</li>
<li style={{ marginBottom: "10px" }}>If you don't get any tracking updates, please write to us at eshop@junaidjamshed.com

</li>
<li style={{ marginBottom: "10px" }}>J. cannot be held liable for late delivery/collection by third-party postal/courier companies. 
</li>

</ul>



<div className="contact" style={{textAlign:"left",marginLeft:"20px", fontFamily:"Alata,sans serif",color:"#303030",fontSize:"16px",marginBottom: "10px"}}><label htmlFor=""><strong>WANT TO AMEND YOUR ORDER</strong></label></div>
<p style={{ fontFamily:"Alata,sans serif",fontSize:"14px",textAlign:"left",}}>You can revise your order so that it's just the way you want it by calling our Customer Services team on&nbsp;021 111 112 111 (9 am - 10 pm, PKT Mon-Sat, 11 am – 8 pm  on Sundays) &nbsp;or emailing us at&nbsp;<a href="/delivery">eshop@junaidjamshed.com</a> before order is processed. If the order hasn’t already been processed, we'll be happy to assist you.</p>


<Useletter/>
<Foter/>


    </div>
  )
}

export default Delivery
